import React from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import KIYGIntro from "./KIYGIntro";
import KIYGCardContent from "./KIYGCardContent";
import { Container } from "react-bootstrap";

const KIYGMainPage = () => {
  return (
    <div>
      {/* Banner */}
      <Breadcrumb
        pageName={KIYGMainPage}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      {/* Basic content for KIYG */}
      <Container>
        {/* subnavigation to be put here */}
        <>
          <KIYGIntro />
          <KIYGCardContent />
        </>
      </Container>
    </div>
  );
};

export default KIYGMainPage;
